<template>
  <v-dialog v-model="dialog" max-width="900">
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row>
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0">Add Allocations</v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-row>
          <v-col sm="6">
            <v-text-field
              v-model="description"
              label="Name/Description (max 100 chars)"
              :maxlength="100"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <date-range-picker
              :gt-date-from-string="validFrom"
              :gt-date-to-string="validTo"
              @onRangeSelected="onDateRangeSelected"
              :outlined="outlinedInputs"
            ></date-range-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              label="Type"
              v-model="type"
              :items="['pax', 'qty']"
              :outlined="outlinedInputs"
            ></v-select>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              v-model="release"
              label="Release"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              v-model="max1"
              label="Mon"
              :outlined="outlinedInputs"
              @change="onMaxChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              v-model="max2"
              label="Tue"
              :outlined="outlinedInputs"
              @change="onMaxChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              v-model="max3"
              label="Wed"
              :outlined="outlinedInputs"
              @change="onMaxChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              v-model="max4"
              label="Thur"
              :outlined="outlinedInputs"
              @change="onMaxChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              v-model="max5"
              label="Fri"
              :outlined="outlinedInputs"
              @change="onMaxChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              v-model="max6"
              label="Sat"
              :outlined="outlinedInputs"
              @change="onMaxChange"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              v-model="max7"
              label="Sun"
              :outlined="outlinedInputs"
              @change="onMaxChange"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-alert dense text type="info"
              >If you select more than one service the Allocation will be shared
              between the selected services.</v-alert
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6">
            <agent-group-select
              v-model="agentGroup"
              :outlined="outlinedInputs"
            ></agent-group-select>
          </v-col>
          <v-col>
            <gt-multi-select
              :items="inUseServices"
              label="Services"
              item-text="node.name"
              item-value="node.id"
              v-model="selectedServices"
              :outlined="outlinedInputs"
            ></gt-multi-select>
            <v-alert
              v-if="selectedServices.length > 1"
              dense
              text
              type="warning"
              class="mt-1 mb-0"
            >
              Shared allocation: {{ selectedServiceNames.join(', ') }}
            </v-alert>
          </v-col>
          <v-col sm="1" v-if="false">
            <v-text-field
              type="number"
              v-model="max"
              label="Max"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="debug">
          <v-col>[{{ max }}]</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <div class="flex-grow-1"></div>
        <v-btn color="warning" text @click="dialog = false">Cancel</v-btn>
        <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DateRangePicker from "../../shared/DatesRangePicker";
import AgentGroupSelect from "../../shared/AgentGroupSelect";
import GtMultiSelect from "../../shared/GtMultiSelect";
export default {
  name: "add-allocations-dialog",
  props: {
    services: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DateRangePicker,
    AgentGroupSelect,
    GtMultiSelect,
  },
  data() {
    return {
      debug: false,
      description: "",
      dialog: false,
      validFrom: "",
      validTo: "",
      agentGroup: "",
      selectedServices: [],
      type: "pax",
      release: 0,
      max1: 0,
      max2: 0,
      max3: 0,
      max4: 0,
      max5: 0,
      max6: 0,
      max7: 0,
      max: 0,
    };
  },

  computed: {
    inUseServices() {
      return this.services.filter((s) => !s.node.notInUse);
    },
    selectedServiceNames() {
      return this.inUseServices
        .filter((s) => this.selectedServices.includes(s.node.id))
        .map((s) => s.node.name);
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.validFrom != "" &&
        this.validTo != "" &&
        this.name != "" &&
        this.selectedServices.length > 0
      );
    },
  },
  methods: {
    onMaxChange(payload) {
      if (Number(payload) > Number(this.max)) {
        this.max = Number(payload);
      }
    },
    onDateRangeSelected(range) {
      this.validFrom = range.dateFrom;
      this.validTo = range.dateTo;
    },
    onBookBeforeSelected(date) {
      this.bookBeforeDate = date;
    },
    onSave() {
      this.dialog = false;
      this.$emit("create", {
        validFrom: this.validFrom,
        validTo: this.validTo,
        groupId: this.agentGroup,
        description: this.description,
        type: this.type,
        services: this.selectedServices,
        release: Number(this.release),
        max1: Number(this.max1),
        max2: Number(this.max2),
        max3: Number(this.max3),
        max4: Number(this.max4),
        max5: Number(this.max5),
        max6: Number(this.max6),
        max7: Number(this.max7),
        max: Number(this.max),
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/allocations/AddAllocationsDialog.vue